import { FC, useContext, useEffect, useMemo } from 'react';
import { useGQLQuery } from 'hooks';
import { QUERY_fetchCommunitySubFacilities } from 'queries';
import { useParams } from 'react-router-dom';
import {
  FetchCommunitySubFacilitiesQuery,
  FetchCommunitySubFacilitiesQueryVariables,
} from 'types/graphql';
import { createGQLDataContext } from 'utils/createDataContext';
import { GQLAPIContextType } from 'types/common.types';

const CustomersSettingsPageDataContext = createGQLDataContext({});

export const CustomersSettingsPageDataProvider: FC = ({ children }) => {
  const { locationId } = useParams<{ locationId: string }>();
  const { data, fetch, ...restQuery } = useGQLQuery<
    FetchCommunitySubFacilitiesQuery,
    FetchCommunitySubFacilitiesQueryVariables
  >({
    key: 'CUSTOMER_SETTINGS',
    query: QUERY_fetchCommunitySubFacilities,
    variables: {
      id: Number(locationId),
    },
  });

  useEffect(() => {
    fetch();
  }, []); // eslint-disable-line

  const contextValue = useMemo(() => ({ data, fetch, ...restQuery }), [data, fetch, restQuery]);

  return (
    <CustomersSettingsPageDataContext.Provider value={contextValue}>
      {children}
    </CustomersSettingsPageDataContext.Provider>
  );
};

export const useCustomersSettingsPageDataContext = () =>
  useContext<GQLAPIContextType<FetchCommunitySubFacilitiesQuery>>(CustomersSettingsPageDataContext);
